import Axios from "axios";
import $ from "jquery";

$.ajaxSetup({
	beforeSend: function (xhr) {
		// $("#loader").show();
	},

	complete: function () {
		$("#loader").hide();
	},
	error: function (err) {
		//console.error(`${err.status} > ${this.url} > ${err.responseText}`);
		$("#loader").hide();
	},
});

// 메인 - 공지사항
export const getNoticeList = () => {
	return Axios.get("/api/getNoticeList");
};

// 메인 - 날씨정보
export const getWeatherList = () => {
	return Axios.get("/api/getWeather");
};

// 시군 코드 가져오기
export const getSggList = () => {
	return Axios.get("/api/com/getSggList");
};

// 읍면동 코드 가져오기
export const getUmdList = (regnCode) => {
	return Axios.get("/api/com/getUmdList?regnCode=" + regnCode);
};

// 리 코드 가져오기
export const getRiList = (regnCode) => {
	return Axios.get("/api/com/getRiList?regnCode=" + regnCode);
};

// 공지사항 - 상세
export const getNoticeDetail = (id) => {
	return Axios.get("/api/getNoticeDetail/" + id);
};

export const getNewsList = () => {
	return Axios.get("/map/getNewsList")
}

// 메인 - 자료실
export const getReferenceList = () => {
	return Axios.get("/api/getReferenceList");
};

// 메인 - 자료실 상세
export const getReferenceDetail = (id) => {
	return Axios.get("/api/getReferenceDetail/" + id);
};

